import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1.25, 1.875),
    border: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
  },

  date: {
    color: theme.palette.text.disabled,
    fontSize: theme.spacing(1.5),
    paddingRight: theme.spacing(1),
  },

  match: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    minWidth: theme.spacing(7),
    minHeight: theme.spacing(7),
    marginRight: theme.spacing(2),

    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  goToGameButton: {
    width: theme.spacing(1.875),
    height: theme.spacing(1.875),
    color: theme.palette.primary.light,
  },

  teamName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  scoreContainer: {
    [theme.breakpoints.down('md')]: {
      minWidth: theme.spacing(10),
    },
  },
}));
